<script>
export default {
    name: 'IconBug',
    props: {
        
    },
    data() {
        return {
            
        }
    },
    computed: {

    },
    methods: {

    }
}
</script>
<template>
  <icon-base><path d="M7 10V2h6v8h5l-8 8-8-8h5z" /></icon-base>
</template>